const mimeTypes: { [key: string]: string } = {
  ".pdf": "application/pdf",
  ".docx":
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ".doc": "application/msword",
  ".xls": "application/vnd.ms-excel",
  ".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ".jpg": "image/jpeg",
  ".jpeg": "image/jpeg",
  ".png": "image/png",
  ".gif": "image/gif",
  ".txt": "text/plain",
  ".html": "text/html",
  ".csv": "text/csv",
  ".zip": "application/zip",
  ".json": "application/json",
  ".pptx":
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
};

function getMimeType(extension: string): string {
  return mimeTypes[extension.toLowerCase()] || "application/octet-stream";
}

export { getMimeType };
